import { IApiRequest } from '../../types';
import { IMOQValidationResponse } from '../../api/MOQ/IMOQValidationResponse';

const initialState: IApiRequest<IMOQValidationResponse> = {
  data: null,
  loading: false,
  error: '',
  UpdatedAt: '',
};

const moqReducer = (state: any = initialState, action: any): IApiRequest<IMOQValidationResponse> => {
  switch (action.type) {
    case 'VALIDATE_MOQ_REQUEST': {
      return {
        ...state,
        loading: true,
      };
    }
    case 'VALIDATE_MOQ_RESPONSE': {
      // Unwrap the response if it's wrapped in a moqValidation property
      const unwrappedData = action.response.moqValidation || action.response;
      return {
        data: unwrappedData,
        loading: false,
        error: '',
        UpdatedAt: new Date().toISOString(),
      };
    }
    case 'VALIDATE_MOQ_ERROR': {
      return {
        data: null,
        loading: false,
        error: 'Failed to validate MOQ',
        UpdatedAt: '',
      };
    }
    case 'CLEAR_MOQ_VALIDATION': {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default moqReducer;
